import {
  AssetSubClassName,
  AssetSubClassNames,
} from '@api/api/entity-constants';

const DEFAULT_USER_LOCALE = 'en-US';
const DEFAULT_CURRENCY = 'USD';
export const SIGNIFICANT_DIGITS_COUNT = 4;

export const priceDecimals = (entitySubClass: AssetSubClassNames) => {
  return (price: number) => {
    if (
      (entitySubClass === AssetSubClassName.GenericCross ||
        entitySubClass === AssetSubClassName.MajorCross) &&
      price <= 100
    ) {
      return 4;
    } else {
      if (price >= 5) {
        return 2;
      }

      if (price === 0) {
        return 2;
      }

      if (price < 5) {
        return 4;
      }
    }

    return 2;
  };
};

export const formatAssetPrice = (
  price: number,
  currency?: string,
  decimals = 2,
  locale = DEFAULT_USER_LOCALE,
  shouldShowCurrency = true
) => {
  try {
    const significantNumberRule = price !== 0 && Math.abs(price) < 1;
    return price
      .toLocaleString(locale, {
        style: currency && shouldShowCurrency ? 'currency' : 'decimal',
        currency,
        minimumFractionDigits: significantNumberRule ? undefined : decimals,
        maximumFractionDigits: significantNumberRule ? undefined : decimals,
        maximumSignificantDigits: significantNumberRule
          ? SIGNIFICANT_DIGITS_COUNT
          : undefined,
      })
      .replace('\u00A0', '');
  } catch {
    return price.toFixed(decimals);
  }
};

export const formatPriceWithCurrency = (
  value: number,
  currency = DEFAULT_CURRENCY,
  decimals = 2,
  locale = DEFAULT_USER_LOCALE
) => {
  try {
    return value
      .toLocaleString(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: decimals,
      })
      .replace('\u00A0', '');
  } catch {
    return value.toFixed(decimals);
  }
};

export const getCurrencySymbol = (
  currency: string,
  locale = DEFAULT_USER_LOCALE
) => {
  try {
    return (0)
      .toLocaleString(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/[\d\u00A0]/g, '')
      .trim();
  } catch {
    return '';
  }
};
